import { ProjectPortfolio } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { DuplicateInspector } from "../../adapters/duplicateInspector";
import { findError } from "../../../entities/errorChecker";
import { validateProjectPortfolio } from "../../entities/validateProjectPortfolio";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function hasChangedName(
  portfolio: ProjectPortfolio,
  nextPortfolio: ProjectPortfolio,
) {
  return portfolio.name !== nextPortfolio.name;
}

function createInteractor(
  repository: Repository,
  inspector: DuplicateInspector,
): Interactor {
  return ({ planzone, portfolio, nextPortfolio }) => {
    const error = validateProjectPortfolio(nextPortfolio);
    const savePortfolio = () =>
      repository
        .updateProjectPortfolio(planzone, portfolio, {
          ...nextPortfolio,
          color: nextPortfolio.color || portfolio.color,
        })
        .then((portfolio) => ({ planzone, portfolio }))
        .catch(() =>
          Promise.reject({
            planzone,
            portfolio,
            nextPortfolio,
            error,
          }),
        );

    return present(
      !findError(error)
        ? hasChangedName(portfolio, nextPortfolio)
          ? inspector
              .isProjectPortfolioDuplicate(planzone, nextPortfolio)
              .then((isDuplicated) =>
                !isDuplicated
                  ? savePortfolio()
                  : Promise.reject({
                      planzone,
                      portfolio,
                      nextPortfolio,
                      error: { ...error, portfolioNameIsNotUnique: true },
                    }),
              )
          : savePortfolio()
        : Promise.reject({ planzone, portfolio, error }),
    );
  };
}

export type { Interactor };

export { createInteractor };
